import * as React from 'react';
import { Layout, Button, Popover, Dropdown, Menu, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import {
	assetsRestCrudThunksForSupplier,
	cancelScheduledAssetTransfer,
} from '../../thunks/assets_thunks';
import BulkTransferToLocationModal from '../supplier_assets_index_page/BulkTransferToLocationModal';
import BulkTransferToStockLocationModal from '../supplier_assets_index_page/BulkTransferToStockLocationModal';
import {
	getProtectedImageUriForSupplier,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { Link } from 'react-router-dom';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import {
	generateBackLink,
	getBackLinkStates,
	getLinkWIthBackLinkParams,
} from '../../utils/HistoryUtils';
import { getBuyerCompanySettingValue, PERMISSION_NAMES } from '../../utils/AuthUtils';
import AssetDetailLabels from '../LabelDisplay/AssetDetailLabels';
import { getScheduledTransferInitialValues } from '../../utils/assetUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';
import { isRefrigerantTrackingEnabled } from '../../utils/FeatureFlagUtils';

const { Content } = Layout;

require('./SupplierAssetsDetailPage.less');

const DEFAULT_BACK_LINK = '/supplier/assets/overview/all';
const DEFAULT_BACK_TEXT = 'Back to assets';

class SupplierAssetsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			manualsIncluded: false,
			transferModal: null,
			fromTargetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	populateNavBar = () => {
		const { location, updateNavbar } = this.props;
		const {
			backLinkText = DEFAULT_BACK_TEXT,
			backLinkTo,
			fromTargetCollectionName = null,
		} = getBackLinkStates(location, DEFAULT_BACK_LINK) as any;
		this.setState({ fromTargetCollectionName });
		updateNavbar(
			backLinkText || DEFAULT_BACK_TEXT,
			backLinkTo || generateBackLink(DEFAULT_BACK_LINK, location)
		);
	};

	componentDidMount() {
		const { getAsset, match, asset } = this.props;
		const assetId = match.params.id;
		this.populateNavBar();
		const updateManualsIncluded = (asset) => {
			const manualsIncluded = !!nullSafeGet('assetModel.manuals', asset);
			this.setState({ manualsIncluded });
		};

		getAsset(assetId).then(updateManualsIncluded);
	}

	componentDidUpdate(prevProps) {
		// React Router reuses this component when the :id changes (e.g. clicking
		// the "Sub Asset of {parent}" link), so refetch here too.
		const prevId = prevProps.match.params.id;
		const nextId = this.props.match.params.id;
		if (prevId !== nextId) {
			const { getAsset, asset } = this.props;
			if (!nullSafeGet('id', asset) || String(asset.id) !== String(nextId)) {
				getAsset(nextId).then((fetched) => {
					this.setState({ manualsIncluded: !!nullSafeGet('assetModel.manuals', fetched) });
				});
			}
		}
	}

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const assetId = match.params.id;
		history.push(`/supplier/assets/detail/${assetId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteAsset, asset } = this.props;
		deleteAsset(asset).then(() => {
			history.push('/supplier/assets/overview/all');
		});
	};

	openSLModal = () => this.setState({ transferModal: 'toSL' });
	openLocationModal = () => this.setState({ transferModal: 'toLocation' });
	closeTransferModal = () => this.setState({ transferModal: null });

	handleEditTransfer = () => {
		const { asset } = this.props;
		const isLocationTransfer = !!nullSafeGet('nextScheduledTransfer.state.locationId', asset);
		this.setState({ transferModal: isLocationTransfer ? 'toLocation' : 'toSL' });
	};

	handleCancelTransfer = () => {
		const { cancelScheduledTransfer, getAsset, match, asset } = this.props;
		const assetId = match.params.id;
		cancelScheduledTransfer({ assetIds: [asset.id] }).then(() => getAsset(assetId));
	};

	handleCopy = () => {
		const { match, history, userType, location } = this.props;
		const assetId = match.params.id;
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to asset',
				`/${userType}/assets/overview/new?copyFromAssetId=${assetId}`
			)
		);
	};

	render() {
		const {
			asset,
			assetsFetching,
			match,
			location,
			history,
			assets,
			updatePagination,
			cloneTargetCollection,
			userType,
			currentUser,
		} = this.props;

		const assetId = match.params.id;
		const assetIsSubAsset = !!nullSafeGet('parentId', asset);
		const subAssetsEnabled = getBuyerCompanySettingValue(ROLE_TYPES.SUPPLIER)(
			'assetConfig.allowSubAssets',
			{},
			currentUser,
			false
		);
		let tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'history',
				name: 'Transfer History',
			},
			// Sub assets don't track their own downtime, so hide the tab.
			...(assetIsSubAsset
				? []
				: [
						{
							key: 'downtimeHistory',
							name: 'Downtime History',
						},
				  ]),
			{
				key: 'depreciationJournal',
				name: 'Depreciation Journal',
				accessPermissionName: PERMISSION_NAMES.SHOW_ASSET_PRICE,
			},
			{
				key: 'depreciationModels',
				name: 'Depreciation Models',
				accessPermissionName: PERMISSION_NAMES.SHOW_ASSET_PRICE,
			},
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];
		// Data-driven rather than config-driven, matching the buyer page. A third-party supplier can
		// read the derived summary here but not the events behind it — the ledger reads fail closed
		// for anyone without a private buyer company — so the tab shows the compliance numbers and an
		// empty ledger for them, which is the server's deliberate asymmetry rather than an error.
		if (isRefrigerantTrackingEnabled() && nullSafeGet('isRefrigerantTracked', asset)) {
			tabs.push({ key: 'refrigerantTracking', name: 'Refrigerant Tracking' });
		}
		if (this.state.manualsIncluded) {
			tabs.push({ key: 'manuals', name: 'Manuals' });
		}
		// Sub assets are a single level deep — don't show the tab on an asset that
		// is itself a sub asset, or when the company hasn't enabled the feature.
		if (!assetIsSubAsset && subAssetsEnabled) {
			tabs.push({ key: 'subAssets', name: 'Sub Assets' });
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (asset.images) {
			photoUris = asset.images.slice(0, 4).map((assetImg) => {
				const [imgFileId, imgFileName] = assetImg.split('/');
				return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = asset.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.SUPPLIER)(photoString, 2400, 1600),
			}));
		}
		const fetching = assetsFetching && !nullSafeGet('id', asset);
		const isSubAsset = !!nullSafeGet('parentId', asset);
		const scheduledTransfer = nullSafeGet('nextScheduledTransfer', asset);
		const isLocationTransfer = !!nullSafeGet('nextScheduledTransfer.state.locationId', asset);
		return (
			<div>
				<Route
					path="/supplier/assets/detail/:id"
					exact={true}
					render={() => (
						<Redirect
							to={{
								pathname: `/supplier/assets/detail/${assetId}/details`,
							}}
						/>
					)}
				/>
				<Content className="supplierAssetsDetailPage">
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								asset.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!asset.isActive ? <div className="assetInactiveLabel">Inactive</div> : null}
							<div className="supplierAssetsDetailPage__overtitle">
								{nullSafeGet('assetType.name', asset)}
							</div>
							<h4 className="supplierAssetsDetailPage__title">{fetching ? null : asset.name}</h4>
							<AssetDetailLabels asset={asset} />
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<div style={{ position: 'absolute', top: 40, right: 40 }}>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<Link
										to={getLinkWIthBackLinkParams(
											location,
											'Back to Asset',
											`/${userType}/assets/edit/${assetId}`
										)}
										style={{ marginRight: 16 }}
									>
										<Button ghost={true}>Edit</Button>
									</Link>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.DELETE_ASSETS}>
									<DeleteConfirmButton
										onConfirm={this.handleDelete}
										title={
											assetIsSubAsset ? (
												'Are you sure you want to delete this sub asset?'
											) : nullSafeGetOrElse('subAssetCount', asset, 0) > 0 ? (
												<div style={{ maxWidth: 320 }}>
													<div>Are you sure you want to delete this asset?</div>
													<div style={{ marginTop: 8 }}>
														It has {asset.subAssetCount} sub asset
														{asset.subAssetCount === 1 ? '' : 's'}, which will also be deleted.
													</div>
												</div>
											) : (
												'Are you sure you want to delete this asset?'
											)
										}
									>
										<Button ghost={true} style={{ marginRight: 16 }}>
											Delete
										</Button>
									</DeleteConfirmButton>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<Popover
										content={isSubAsset ? 'Sub assets cannot be copied to create a new asset' : ''}
										trigger="hover"
									>
										<span style={{ display: 'inline-block', marginRight: 16 }}>
											<Button ghost={true} onClick={this.handleCopy} disabled={isSubAsset}>
												Copy and create new
											</Button>
										</span>
									</Popover>
									{scheduledTransfer ? (
										<Popover
											content={isSubAsset ? 'Sub assets cannot be transferred' : ''}
											trigger="hover"
										>
											<span style={{ display: 'inline-block' }}>
												<Dropdown
													overlay={
														<Menu>
															<Menu.Item onClick={this.handleEditTransfer}>Edit Transfer</Menu.Item>
															<Menu.Item>
																<Popconfirm
																	title="Cancel this scheduled transfer?"
																	onConfirm={this.handleCancelTransfer}
																	okText="Cancel Transfer"
																	cancelText="Keep"
																	okButtonProps={{ danger: true }}
																>
																	<span style={{ display: 'block' }}>Cancel Transfer</span>
																</Popconfirm>
															</Menu.Item>
														</Menu>
													}
													disabled={isSubAsset}
												>
													<Button ghost={true} disabled={fetching || isSubAsset}>
														Transfer
													</Button>
												</Dropdown>
											</span>
										</Popover>
									) : (
										<Popover
											content={
												isSubAsset
													? 'Sub assets cannot be transferred'
													: !asset.isActive
													? 'Inactive assets cannot be transferred'
													: ''
											}
											trigger="hover"
										>
											<span style={{ display: 'inline-block' }}>
												<Dropdown
													overlay={
														<Menu>
															<Menu.Item onClick={this.openSLModal}>To Stock Location</Menu.Item>
															<Menu.Item onClick={this.openLocationModal}>To Location</Menu.Item>
														</Menu>
													}
													disabled={isSubAsset}
												>
													<Button ghost={true} disabled={!asset.isActive || fetching || isSubAsset}>
														Transfer
													</Button>
												</Dropdown>
											</span>
										</Popover>
									)}
								</AccessPermissionChecker>
							</div>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white' }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', asset)}
									getEnitityUrl={(id) => `/supplier/assets/detail/${id}/details`}
									stateSlice={assets}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="asset"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
					{this.state.transferModal === 'toSL' && (
						<BulkTransferToStockLocationModal
							assets={[asset]}
							currentStockLocationId={nullSafeGet('stockLocation.id', asset)}
							{...(scheduledTransfer &&
								!isLocationTransfer && {
									transferId: scheduledTransfer.triggerAt,
									initialValues: getScheduledTransferInitialValues(asset),
								})}
							onCancel={this.closeTransferModal}
							onSuccess={() => {
								this.closeTransferModal();
								this.props.getAsset(assetId);
							}}
						/>
					)}
					{this.state.transferModal === 'toLocation' && (
						<BulkTransferToLocationModal
							assets={[asset]}
							currentLocationId={nullSafeGet('location.id', asset)}
							{...(scheduledTransfer &&
								isLocationTransfer && {
									transferId: scheduledTransfer.triggerAt,
									initialValues: getScheduledTransferInitialValues(asset),
								})}
							onCancel={this.closeTransferModal}
							onSuccess={() => {
								this.closeTransferModal();
								this.props.getAsset(assetId);
							}}
						/>
					)}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	userType: state.session.userType,
	currentUser: state.session.currentUser,
	assets: state.assets,
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForSupplier.readOne(id)),
	cancelScheduledTransfer: (data) =>
		dispatch(cancelScheduledAssetTransfer(ROLE_TYPES.SUPPLIER)(data)),
	deleteAsset: (entity) =>
		dispatch(assetsRestCrudThunksForSupplier.delete(entity, 'id', null, true)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('supplier', 'assets', assetsRestCrudThunksForSupplier)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierAssetsDetailPage));
